module.exports = __webpack_public_path__ + "fonts/roboto-mono-v13-latin-regular.0f03f6f.woff";